export type ArticleLinkFields = {
  article_url?: string;
  canonical_url?: string;
};

export function getPrimaryArticleUrl(article: ArticleLinkFields): string {
  return article.article_url || article.canonical_url || "#";
}

function getHostname(url: string | undefined): string {
  if (!url) {
    return "";
  }

  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return "";
  }
}

function isHkEpochTimesHost(hostname: string): boolean {
  return hostname === "hk.epochtimes.com" || hostname === "www.hk.epochtimes.com";
}

export function shouldShowCanonicalLink(article: ArticleLinkFields): boolean {
  const primaryUrl = getPrimaryArticleUrl(article);
  const canonicalUrl = article.canonical_url;

  if (!article.article_url || !canonicalUrl || primaryUrl === canonicalUrl) {
    return false;
  }

  const canonicalHost = getHostname(canonicalUrl);
  return canonicalHost !== "" && !isHkEpochTimesHost(canonicalHost);
}
